import { calculateEnergyKcal } from "@/lib/calculateEnergyKcal";
import { calculatePAC } from "@/lib/calculatePAC";
import { calculatePOD } from "@/lib/calculatePOD";
import { MILKFAT_SATURATED_FAT_PERCENTAGE } from "@/lib/constants";
import { clamp, roundToNearest } from "@/lib/utils";
import type { IngredientDraft } from "./preparation";
import { roundIngredientFraction as roundFraction } from "./units";
type DairyComposition = Pick<
  IngredientDraft,
  | "fatPct"
  | "waterPct"
  | "proteinPct"
  | "carbPct"
  | "fiberPct"
  | "alcoholPct"
  | "sugarsPct"
  | "lactosePct"
  | "saturatedFatPct"
  | "energyKcal"
  | "pod"
  | "pac"
>;

export function calculateDairyComposition(fatPct: number): DairyComposition {
  const proteinPct = -0.022 * fatPct + 0.034;
  const sugarsPct = clamp(roundFraction(-0.049 * fatPct + 0.048, 0.1), 0, 1);
  const waterPct = clamp(roundFraction(-0.965 * fatPct + 0.917, 0.1), 0, 1);

  return {
    fatPct,
    waterPct,
    proteinPct: clamp(roundFraction(proteinPct, 0.1), 0, 1),
    carbPct: clamp(roundFraction(sugarsPct, 0.1), 0, 1),
    fiberPct: 0,
    alcoholPct: 0,
    sugarsPct: clamp(roundFraction(sugarsPct, 0.1), 0, 1),
    lactosePct: clamp(roundFraction(sugarsPct, 0.1), 0, 1),
    saturatedFatPct: clamp(
      roundFraction(fatPct * MILKFAT_SATURATED_FAT_PERCENTAGE, 0.1),
      0,
      1,
    ),
    energyKcal: roundToNearest(
      calculateEnergyKcal({
        fatPct: fatPct,
        proteinPct: proteinPct,
        sugarsPct: sugarsPct,
      }),
      0.1,
    ),
    pod: calculatePOD({ lactose: sugarsPct }),
    pac: calculatePAC({ lactose: sugarsPct }),
  };
}
